import React, { useRef } from 'react';
import { getUploadUrl } from '../utils/config';
import './Avatar.css';

function Avatar({ photoUrl, firstName, lastName, size = 150, onClick, onRemove, editable = false }) {
  const fileInputRef = useRef(null);
  const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();

  // Generate consistent color from name
  const hash = (firstName + lastName).split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const hue = hash % 360;

  const handleClick = () => {
    if (editable && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file && onClick) {
      onClick(file);
    }
    // Reset input so same file can be selected again
    e.target.value = '';
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    if (onRemove) {
      onRemove();
    }
  };

  return (
    <div
      className={`avatar-wrapper ${editable ? 'avatar-editable' : ''}`}
      style={{ width: size, height: size }}
    >
      <div
        className="avatar"
        style={{ width: size, height: size }}
        onClick={handleClick}
      >
        {photoUrl ? (
          <img
            src={getUploadUrl(photoUrl)}
            alt={`${firstName} ${lastName}`}
            className="avatar-photo"
          />
        ) : (
          <div
            className="avatar-initials"
            style={{ backgroundColor: `hsl(${hue}, 45%, 65%)` }}
          >
            {initials}
          </div>
        )}
        {editable && (
          <div className="avatar-overlay">
            <span className="avatar-overlay-text">Change</span>
          </div>
        )}
      </div>
      {editable && photoUrl && onRemove && (
        <button
          className="avatar-remove-btn"
          onClick={handleRemove}
          title="Remove photo"
        >
          &times;
        </button>
      )}
      {editable && (
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          hidden
        />
      )}
    </div>
  );
}

export default Avatar;
